export default function SectionRule({ number, label }) {
  return (
    <div className="section-rule">
      <span>{number}</span>
      <span className="rule-line" />
      <span>{label}</span>
    </div>
  );
}
